import { useEffect, useState } from "react";
import { ewaiverApi } from "../api/ewaiver.service";

export const useGetTracking = (id: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async (id: string) => {
    setLoading(true);
    try {
      const res = await ewaiverApi.getTracking(id);
      const data = res?.data;

      setData(data?.data);
    } catch (error: any) {
      console.log("Get ewaiver tracking failed:", error);

      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return { data, fetchData, loading, error };
};
